<form (change)="saveForm()" [formGroup]="relatieGegevens">
    <div class="row">
        <div formArrayName="relaties">
            <div *ngFor="let relatieGegevens of relaties.controls; let i = index; "
                 [formGroupName]="i">

                <b>1. Gehuwd? Vermeld de wijziging in {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} in de huwelijkse
                    staat</b><br>
                <div class="space20"></div>

                <div class="row col-auto">
                    <snelstart-ui-date-form-control class="custom-input-250 "
                                                    formControlName="datumTrouwen"
                                                    id="datumTrouwen"
                                                    label="Datum trouwen in {{this.incomeTaxEntity.aangifte?.aangifteJaar}}"

                    >
                    </snelstart-ui-date-form-control>

                    <snelstart-ui-date-form-control class="custom-input-250 "
                                                    formControlName="datumScheiding"
                                                    id="datumScheiding"
                                                    label="Datum scheiding in {{this.incomeTaxEntity.aangifte?.aangifteJaar}}"

                    >
                    </snelstart-ui-date-form-control>

                    <snelstart-ui-date-form-control class="custom-input-250 "
                                                    formControlName="datumOverlijdenPartner"
                                                    id="datumOverlijdenPartner"
                                                    label="Datum overlijden partner in {{this.incomeTaxEntity.aangifte?.aangifteJaar}}"
                    >
                    </snelstart-ui-date-form-control>
                </div>

                <div class="space20"></div>


                <b>2. Samenwonend? Vermeld de periode van inschrijving op hetzelfde adres
                    in {{ this.incomeTaxEntity.aangifte?.aangifteJaar }}</b><br>

                <div class="space20"></div>

                <div formGroupName="periodeIngeschrevenOpZelfdeAdres">
                    <div class="row col-auto">
                        <snelstart-ui-date-form-control class="custom-input-250"
                                                        formControlName="begindatum"
                                                        id="begindatum"
                                                        label="Begin inschrijving in {{this.incomeTaxEntity.aangifte?.aangifteJaar}}"
                        >
                        </snelstart-ui-date-form-control>
                        <snelstart-ui-date-form-control class="custom-input-250"
                                                        formControlName="einddatum"
                                                        id="einddatum"
                                                        label="Einde inschrijving in {{this.incomeTaxEntity.aangifte?.aangifteJaar}}"

                        >
                        </snelstart-ui-date-form-control>
                    </div>
                    <div class="pt-2" style="width: 75%">
                        <snelstart-ui-alert type="info">
                            Vermeld de situatie voor het jaar {{ this.incomeTaxEntity.aangifte?.aangifteJaar! }}.
                            Begint het samenwonen al voor 1 januari {{ this.incomeTaxEntity.aangifte?.aangifteJaar! }}?
                            Vermeld dan '01-01-{{ this.incomeTaxEntity.aangifte?.aangifteJaar! }}'.
                            Eindigt het samenwonen na 31 december {{ this.incomeTaxEntity.aangifte?.aangifteJaar! }}?
                            Vermeld dan '31-12-{{ this.incomeTaxEntity.aangifte?.aangifteJaar! }}'.
                        </snelstart-ui-alert>
                    </div>
                </div>

                <div class="space20"></div>

                <b>3. Bepalen fiscaal partnerschap</b><br>

                <p *ngIf="!relaties.controls[i].get('datumTrouwen')?.value &&
                            !relaties.controls[i].get('datumScheiding')?.value &&
                            !relaties.controls[i].get('datumOverlijdenPartner')?.value &&
                            !(relaties.controls[i].get('periodeIngeschrevenOpZelfdeAdres.begindatum')?.value && relaties.controls[i].get('periodeIngeschrevenOpZelfdeAdres.einddatum')?.value)"
                   class="ps-2"
                >Vul eerst de van toepassing zijn gegevens in bij 1. of 2.</p>

                <div *ngIf="relaties.controls[i].get('datumTrouwen')?.value ||
                            relaties.controls[i].get('datumScheiding')?.value ||
                            relaties.controls[i].get('datumOverlijdenPartner')?.value ||
                            (relaties.controls[i].get('periodeIngeschrevenOpZelfdeAdres.begindatum')?.value && relaties.controls[i].get('periodeIngeschrevenOpZelfdeAdres.einddatum')?.value)">

                    <div class="space10"></div>

                    <p class="ps-1">Is een van de volgende situaties
                        in {{ this.incomeTaxEntity.aangifte?.aangifteJaar! }} van toepassing:</p>
                    <div>
                        <ul>
                            <li>Aangever en partner zijn een deel van het jaar gehuwd of geregistreerd partner.</li>
                            <li>Aangever en partner hebben samen een notarieel samenlevingscontract.</li>
                            <li>Aangever en partner hebben samen een kind.</li>
                            <li>De ene partner erkent een kind van de ander.</li>
                            <li>Aangever en partner zijn samen eigenaar van een woning (hoofdverblijf).</li>
                            <li>Er woont een minderjarig kind van een van beiden op het woonadres.</li>
                            <li>Aangever en partner zijn partners voor een pensioenregeling.</li>
                            <li>Aangever en partner waren in {{ this.incomeTaxEntity.aangifte?.aangifteJaar! - 1 }}
                                samenfiscaal partners.
                            </li>
                        </ul>
                    </div>
                    <div>
                        <snelstart-ui-select-form-control
                                (change)="saveForm()"
                                [options]="optionsJaNeeVoorwaarden"
                                [required]=true
                                class="custom-input-250"
                                formControlName="voldaanAanFiscaalPartnerschapVoorwaarden"
                                label="Selecteer"
                        >
                        </snelstart-ui-select-form-control>
                    </div>
                    <div
                            *ngIf="relaties.controls[i].get('voldaanAanFiscaalPartnerschapVoorwaarden')?.getRawValue() === true">
                        <snelstart-ui-select-form-control
                                (change)="saveForm()"
                                [options]="optionsJaNee"
                                [required]=true
                                class="custom-input-250"
                                formControlName="kiestVoorHeleJaarPartnerschap"
                                label="Keuze voor heel jaar fiscaal partner"
                        >
                        </snelstart-ui-select-form-control>
                    </div>
                    <div class="pt-2" style="width: 75%">
                        <snelstart-ui-alert type="info">
                            Met 'Ja' geven aangever en partner aan
                            heel {{ this.incomeTaxEntity.aangifte?.aangifteJaar }} fiscale partners te willen zijn.
                            Je doet dan samen aangifte doen en je kunt bepaalde inkomsten, uitgaven en bezittingen
                            gunstig verdelen. Hierdoor betalen de partners vaak minder belasting of krijgen ze
                            (extra) heffingskortingen.
                            <div class="space20"></div>
                            <i>N.b. De keuze om niet heel het jaar fiscaal partners te zijn wordt nog niet
                                ondersteund binnen SnelStart Fiscaal.</i>
                        </snelstart-ui-alert>
                    </div>
                </div>




                <!--                <div class="left">-->
                <!--                    <snelstart-ui-select-form-control-->
                <!--                            formControlName="voldaanAanFiscaalPartnerschapVoorwaarden"-->
                <!--                            label="Selecteer situatie in {{this.incomeTaxEntity.aangifte?.aangifteJaar}}"-->
                <!--                            [options]="optiesRelaties"-->
                <!--                            class="custom-input-250"-->
                <!--                            [required]=true-->
                <!--                            (change)="saveForm()"-->
                <!--                    >-->
                <!--                    </snelstart-ui-select-form-control>-->
                <!--                </div>-->

            </div>
        </div>
    </div>
</form>

<div *ngIf="relaties.length === 0">
    <snelstart-ui-button (click)="addRijRelatiegegevens()" class="snelstart-ui-button pb-3" icon="plus" id="cancelKind"
                         type="link">Wijziging in burgerlijke staat invullen
    </snelstart-ui-button>
</div>


